import GridderJS from "../src/gridder-js";

window.GridderJS = GridderJS;

export default GridderJS;